module.exports = __webpack_public_path__ + "static-portal/img/jr01.94f74df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jr01.jpg
// module id = y2ms
// module chunks = 4